import { OfferHistory } from '../../../../../shared/models/offer-history.model';
import { Component, OnInit, OnDestroy, Input, ViewChild } from '@angular/core';
import {
  BuyErrors,
  LaunchDarklyService,
  FinanceSource,
  multiLanguageAlphaNumericRegexHelper
} from 'remarketing-angular-library';
import { UntypedFormGroup, Validators, UntypedFormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OfferModalAction } from '../../../../../shared/directives/offer-modal-action/offer-modal-action';
import { get } from 'lodash';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Store } from '@ngxs/store';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { HigherExistingOfferComponent } from '../../higher-existing-offer/higher-existing-offer.component';
import { AnalyticsService, MakeOffer, Cancel, CurrencyFormatService } from 'smartauction-frontend-micro-library';
import { CharacterCountComponent, CharacterCountDirective, CurrencyInputComponent, InputConfig } from 'remarketing-ui-components-lib';
import { CommonModule } from '@angular/common';
import { OfferModalsHeaderComponent } from 'src/shared/ui/comment/modal-actions/offer-header/offer-modals-header.component';
import { VehicleChangedWarningComponent } from '../../vehicle-changed-warning/vehicle-changed-warning.component';
import { OfferHistoryComponent } from '../../offer-history/offer-history.component';
import { ModalCloseComponent } from 'src/shared/ui/comment/modal-actions/modal-close/modal-close.component';
import { ActionSubmittingComponent } from 'src/shared/ui/comment/modal-actions/action-submitting/action-submitting.component';
import { ActionSubmittedComponent } from 'src/shared/ui/comment/modal-actions/action-submitted/action-submitted.component';
import { DripFeeSource, DripPricingService } from 'src/shared/services/drip-pricing/public-api';
import { FeeToolTipService } from 'src/shared/services/feetooltip/feetooltip.service';
import {
  ModalPriceBreakdownComponent,
  modalTotalDueOf,
  showsTransportationFee
} from 'src/shared/components/modal-price-breakdown/modal-price-breakdown.component';
import {
  ModalPriceBreakdownPattern,
  ModalPriceBreakdownRow,
  ModalPriceBreakdownTranslations
} from 'src/shared/components/modal-price-breakdown/modal-price-breakdown.types';

@Component({
    selector: 'app-follow-up-offer',
    templateUrl: './follow-up-offer.component.html',
    styleUrls: ['./follow-up-offer.component.scss'],
    imports: [
        TranslocoDirective,
        CommonModule,
        OfferModalsHeaderComponent,
        VehicleChangedWarningComponent,
        OfferHistoryComponent,
        FormsModule,
        ReactiveFormsModule,
        CharacterCountComponent,
        ModalCloseComponent,
        HigherExistingOfferComponent,
        ActionSubmittingComponent,
        ActionSubmittedComponent,
        CurrencyInputComponent,
        CharacterCountDirective,
        RouterLink,
        ModalPriceBreakdownComponent
    ]
})
export class FollowUpOfferComponent extends OfferModalAction implements OnInit, OnDestroy {
  @Input() offerHistory: OfferHistory[];
  @Input() financeSource: FinanceSource;
  form: UntypedFormGroup;
  private readonly destroyed$ = new Subject();
  sellingDisclosureUrl: string;
  characterCountData: any;
  BuyErrors = BuyErrors;
  private intialOffer = true;

  inputConfig: InputConfig = {
    inputClass: 'form-control modal__form-control stockwave-bid-buy-amount',
    inputName: 'offerAmount',
    inputFormControlName: 'offerAmount',
    inputAttrAriaLabelledBy: 'follow-up-offer-label follow-up-offer-error',
    thousandSeparator: '',
    isFrenchCanadian: this.isFrenchCanadian
  };

  followUpOfferTranslations = {
    msgDescriptionImportant: '',
    msgDescriptionBySelecting: '',
    msgDescriptionMakeOffer: '',
    msgDescriptionPartOne: '',
    msgDescriptionPartTwo: '',
    msgDescriptionTransportation: ''
  };

  @ViewChild(HigherExistingOfferComponent) higherExistingOfferModal: HigherExistingOfferComponent;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private readonly analyticsService: AnalyticsService,
    private readonly store: Store,
    private readonly _launchDarklyService: LaunchDarklyService,
    private readonly translocoService: TranslocoService,
    private readonly dripPricingService: DripPricingService,
    private readonly feeToolTipService: FeeToolTipService,
    private readonly currencyFormatService: CurrencyFormatService
  ) {
    super();
  }

  get highestOfferAmount(): any {
    return get(this.offerHistory, '[0].offer.highestOfferAmount', null);
  }

  get isCanadianTenantEnabled(): boolean {
    return this._launchDarklyService.getFeatureFlag('canadianTenantEnabled', false);
  }

  get isFrenchCanadian(): boolean {
    const frenchLanguage = this.translocoService.getActiveLang().includes('fr');
    return frenchLanguage && this.isCanadianTenantEnabled;
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      offerAmount: ['', Validators.required],
      offerComment: ['']
    });
    this.store
      .select(state => state.configuration.configuration)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(configuration => {
        this.sellingDisclosureUrl = get(configuration, 'sellingDisclosureUrl', null);
      });
    this.getTranslations();
  }

  getTranslations() {
    const keyParams = {
      'common.currency': {},
      UIComponents: {},
      'vehicles.followUpOffer': {}
    };
    this.translocoService
      .selectTranslateObject(keyParams)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(translatedObj => {
        this.inputConfig.thousandSeparator = translatedObj[0].thousandSeparator;
        this.characterCountData = translatedObj[1].characterCount;
        this.followUpOfferTranslations.msgDescriptionImportant = translatedObj[2].msgDescriptionImportant;
        this.followUpOfferTranslations.msgDescriptionBySelecting = translatedObj[2].msgDescriptionBySelecting;
        this.followUpOfferTranslations.msgDescriptionMakeOffer = translatedObj[2].msgDescriptionMakeOffer;
        this.followUpOfferTranslations.msgDescriptionPartOne = translatedObj[2].msgDescriptionPartOne;
        this.followUpOfferTranslations.msgDescriptionPartTwo = translatedObj[2].msgDescriptionPartTwo;
        this.followUpOfferTranslations.msgDescriptionTransportation = translatedObj[2].msgDescriptionTransportation;
      });
  }

  get showSellingDisclosure(): boolean {
    return this._launchDarklyService.getFeatureFlag('disclosuresLinkEnabled', false);
  }

  get showVOCItems(): boolean {
    return this._launchDarklyService.getFeatureFlag('vocItemsEnabled', false);
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  get vehicleTitle() {
    const { modelYear = '', make = '', model = '', trim = '' } = this.item;
    return `${modelYear ? `${modelYear} ` : ''}${make} ${model} ${trim} - VIN `;
  }

  replaceInvalidCharacters(e) {
    e.target.value = multiLanguageAlphaNumericRegexHelper(e.target.value);
  }

  newOffer() {
    const offerAmount = this.parsedOfferAmount();
    const offerComment = this.form.get('offerComment').value;

    if (offerAmount) {
      if (this.highestOfferAmount && offerAmount < this.highestOfferAmount) {
        this.intialOffer = false;
        return;
      } else {
        this.event.emit(new MakeOffer(offerAmount, offerComment));
      }
    } else {
      this.errorMessage = BuyErrors.MSG_BUY_003;
      const error = document.getElementById('make_offer_modal_input');
      error.focus();
      // send tracking data
      const inventoryItemUuid = get(this.route, 'snapshot.parent.children[0].params.inventoryItemUuid', null);
      const analyticsPayload = new MakeOffer(offerAmount, offerComment);

      this.analyticsService.track('customEvent', {
        name: analyticsPayload.type.split('Offer').join('') + ' Offer',
        attr: this.analyticsService.createOfferModalEventAnalyticsPayload(
          analyticsPayload,
          this.errorMessage,
          inventoryItemUuid
        )
      });
    }

    this.form.reset();
  }

  get errorLocation(): 'modal' | 'followUp' {
    if (!this.errorMessage) {
      return null;
    }

    if (
      this.errorMessage === BuyErrors.MSG_BUY_002 ||
      this.errorMessage === BuyErrors.MSG_BUY_003 ||
      this.errorMessage === BuyErrors.MSG_BUY_004 ||
      this.errorMessage === BuyErrors.MSG_BUY_005 ||
      this.errorMessage === BuyErrors.MSG_BUY_007 ||
      this.errorMessage === BuyErrors.MSG_BUY_014
      // MSG_BUY_014 is a function
    ) {
      return 'followUp';
    }
    return 'modal';
  }

  isFinanceSourceFeeIncluded() {
    return this.financeSource?.feeAmount != null && this.financeSource?.feeAmount != 0;
  }

  /**
   * The offer amount as digits.
   *
   * newOffer(), continue() and the breakdown's base amount all read this, so the number submitted and
   * the number totalled are the same number.
   *
   * This REPLACES newOffer()'s raw form value, which is a behaviour change and is meant to be: today
   * newOffer() emits whatever the control holds while continue() emits parseInt of it, so the same
   * component already submits a string on one route and a number on the other. The breakdown makes that
   * latent disagreement material -- it would be totalling digits while newOffer() submitted a string --
   * so the two routes are brought onto one parser rather than a third opinion being added. The emitted
   * figure is unchanged; only its type is, and it now matches what InitialOfferComponent has emitted
   * since M4.4 through the same host.
   *
   * The masked field already hands back separator-free digits (ngx-mask defaults dropSpecialCharacters
   * to true), so the strip below is not what makes today's behaviour correct -- it is what keeps it
   * correct if that ever changes. parseInt('59,000') is 59, which would be a wrong figure under a
   * binding-offer disclosure rather than an obvious failure.
   *
   * String() rather than a null check: form.reset() leaves the control null, which yields NaN here.
   * newOffer()'s falsy guard rejects it exactly as it rejected the empty string, and the breakdown
   * renders it as '$--'.
   */
  private parsedOfferAmount(): number {
    return parseInt(String(this.form?.get('offerAmount')?.value).replace(/[^\d]/g, ''), 10);
  }

  // ---------------------------------------------------------------------------
  // All-in pricing (drip pricing, Canada's Competition Act) -- M4.6
  //
  // The same Pattern B treatment as M4.4's InitialOfferComponent, because this is the same Make Offer
  // surface: the buyer reaches it instead of initial-offer when a previous negotiation on the vehicle
  // ended (cancelled, expired, declined or withdrawn by either side, or the vehicle was pulled while
  // still accepting offers). It renders the dead offer chain above the form; the form itself is the
  // same binding offer, so the same disclosure obligation applies.
  //
  // The buyer names the amount, so there is no system-composed headline to decompose. The currency
  // field is projected into the breakdown's base-amount row and the total beneath it updates as the
  // buyer types, so the all-in figure their offer commits them to is on screen before they submit
  // rather than implied by "plus any applicable charges or fees".
  //
  // M4.6 left the disclosure prose alone, as M4.4 did. M4.13 replaces it with the sentence the comp
  // specifies, below the breakdown, quoting the total -- see offerQuotedPriceDisplay.
  //
  // No comp exists for THIS modal; the wording is initial-offer's (10493:16256), applied unchanged. The
  // two are the same Make Offer surface for two entry conditions, so a buyer making a second offer
  // reading a different disclosure from one making a first would be the defect, not the duplication.
  // Flagged for the story owner rather than treated as settled.
  // ---------------------------------------------------------------------------

  /**
   * Prefix for the breakdown's generated ids.
   *
   * Deliberately the same 'mom_price' InitialOfferComponent uses, and not a follow-up-specific value:
   * the two components are the same Make Offer modal for two entry conditions and are never on screen
   * together, so one prefix means automation and analytics target one set of ids for "the all-in total
   * on Make Offer" regardless of which variant the offer status resolved to. A distinct prefix would
   * split that in two for no behavioural gain.
   */
  readonly dripIdPrefix = 'mom_price';

  /** Pattern B: the base amount is the buyer's own, rendered as the projected currency field. */
  readonly additivePattern = ModalPriceBreakdownPattern.ADDITIVE;

  /**
   * The listing's fee schedule, forwarded by OfferModalsComponent.
   *
   * buyFee rather than bidItem.buyFee: this modal opens for vehicles that are not on the buyer's bid
   * list, where bidItem is undefined, so reading it directly would leave the breakdown off for the
   * majority of offers. The host's setInstanceValue('buyFee', ...) is component-agnostic, so both hosts
   * already populate this -- M4.6 adds no host plumbing.
   */
  private get dripFeeSource(): DripFeeSource {
    return this.buyFee;
  }

  /**
   * The breakdown's base amount: what the buyer has typed, or undefined when the field is empty.
   *
   * undefined rather than 0, so an empty field renders the '$--' placeholder. A total of $0 under a
   * binding-offer disclosure is a materially wrong figure; a missing one is merely missing.
   */
  get dripOfferBaseAmount(): number | undefined {
    const parsed = this.parsedOfferAmount();
    return Number.isFinite(parsed) ? parsed : undefined;
  }

  /**
   * Two conditions only -- the flag and the fee source.
   *
   * Deliberately NOT gated on having an amount: the buyer types it, so an empty field is the normal
   * opening state and the breakdown has to be on screen to be typed into.
   *
   * The fee source is required because without it requiredFeesOf returns [] and the "total" would
   * equal the offer amount, presenting a bare offer as an all-in figure.
   *
   * Tested with hasFeePayload rather than `!!this.buyFee`. Truthiness is not the same question: `{}`
   * and `{ fees: null }` are both truthy and both carry no fees, so `!!` admits exactly the case the
   * paragraph above says it exists to exclude. hasFeePayload asks whether a fee COLLECTION arrived,
   * which is the condition that makes the total meaningful.
   *
   * Not requiredFeesOf(...).length either, and the service docblock says so explicitly: a payload that
   * arrived carrying no required fee must still render, with the all-in total legitimately equal to the
   * bare amount. Gating on the row count would withhold the breakdown from a correct zero-fee answer.
   *
   * And no unusable required fee. requiredFeesOf drops a fee whose amount is not finite, so the rows and
   * the TOTAL PURCHASE PRICE would be short by exactly the fee the buyer must pay -- the failure
   * hasUnusableRequiredFee exists to prevent. Buy Now, Withdraw and Counter catch it through
   * allInPriceOf; this modal has no all-in price of its own to check, because the buyer types the amount.
   */
  get showDripBreakdown(): boolean {
    return this.dripPricingService.isDripPricingEnabled
      && this.dripPricingService.hasFeePayload(this.dripFeeSource)
      && !this.dripPricingService.hasUnusableRequiredFee(this.dripFeeSource);
  }

  get dripTransportationFee(): number | undefined {
    return this.dripPricingService.transportationFeeOf(this.dripFeeSource);
  }

  /**
   * Governs the transportation row's companion paragraph. Same exported helper the row itself uses, so
   * the two cannot drift -- do not re-derive it as `fee > 0`.
   */
  get showTransportationDisclosure(): boolean {
    return showsTransportationFee(this.dripTransportationFee);
  }

  formatCurrency(currency, withCents?) {
    return this.currencyFormatService.formatCurrency(currency, withCents);
  }

  /**
   * The offer as a modal total: the required fees and optional transportation on top of the amount the
   * buyer typed. Not a second calculation of it -- the same exported helper the breakdown's own total
   * row uses, so the bold figure and the sentence beneath it cannot disagree by construction.
   */
  get dripOfferTotalDue(): number | undefined {
    return modalTotalDueOf(this.dripOfferBaseAmount, this.dripFeeRows, this.dripTransportationFee);
  }

  /**
   * The figure quoted in the binding-offer sentence, transportation INCLUDED.
   *
   * This reverses the note left here in M4.4, which argued the prose should not be reworded at all: for
   * an offer the fees genuinely ARE added on top of the amount the buyer names, so today's sentence is
   * not the misstatement it is under Buy Now. That reading stands on its own terms, but the comp answers
   * a different question -- what the buyer is bound to -- and answers it with the total. The matched Buy
   * Now pair (10360:9184 with transportation, 10360:9217 without) settles which figure that is: the
   * quoted number moves with the total between the two frames rather than staying on the all-in
   * subtotal. Quoting anything other than the figure in the row directly above would put a second,
   * unexplained number in the same panel, which is the defect this epic exists to remove.
   *
   * Falls back to the breakdown's own '$--' placeholder rather than formatting undefined: the buyer has
   * not typed an amount when the modal opens, and '$0' or '$NaN' inside a binding-offer disclosure is a
   * wrong figure rather than an obviously missing one. Same shape as the bid modal's and the counter
   * tab's, for the same reason -- in all three the buyer names the amount.
   *
   * withCents: false moves with the breakdown's [showCents]="false". The sentence quotes the figure in
   * the total row directly above it, so the two must be formatted the same way or the modal states one
   * number twice -- '$50,750.00' in prose under a '$50,750' band.
   */
  get offerQuotedPriceDisplay(): string {
    const amount = this.dripOfferTotalDue;
    return amount === undefined
      ? this.feeToolTipService.dripTranslations.textTotalPlaceholder
      : this.formatCurrency(amount, false);
  }


  /**
   * The fee rows, cached by content.
   *
   * Not an optimisation: translatedRequiredFeesOf maps a fresh array per call, and a template binding
   * is re-evaluated every change-detection pass, so returning it directly would hand the OnPush child
   * a new identity each pass and trip NG0100 in development builds. Keying on the serialised content
   * keeps the reference stable while still picking up a real change.
   */
  get dripFeeRows(): ModalPriceBreakdownRow[] {
    const rows = this.feeToolTipService.translatedRequiredFeesOf(this.dripFeeSource);
    const key = JSON.stringify(rows);
    if (key !== this.dripFeeRowsKey) {
      this.dripFeeRowsKey = key;
      this.dripFeeRowsCache = rows;
    }
    return this.dripFeeRowsCache;
  }

  /**
   * Cached by content for the same reason as dripFeeRows.
   *
   * labelBaseAmount is the drip bundle's labelOfferAmount rather than
   * vehicles.followUpOffer.labelOfferAmount. The two happen to read the same today ('OFFER AMOUNT'),
   * so this is about which bundle owns the breakdown's copy, not about the string: every other modal's
   * breakdown reads the shared drip bundle, and a copy change there should not have to be repeated in
   * this component's own block to take effect. The fee labels arrive asynchronously, so the key changes
   * when they land and this cache does not stick to the empty strings it sees first.
   */
  get dripBreakdownTranslations(): ModalPriceBreakdownTranslations {
    const drip = this.feeToolTipService.dripTranslations;
    const translations: ModalPriceBreakdownTranslations = {
      labelBaseAmount: drip.labelOfferAmount,
      // Unused by ADDITIVE, which has no sub-rows, but the contract is required.
      labelVehiclePrice: drip.labelVehiclePrice,
      labelTransportationFee: this.feeToolTipService.feeTranslations.TRANSPORTATION_FEE,
      // labelModalTotalDue, never labelTotalPurchasePrice: this total INCLUDES transportation while the
      // list-surface total excludes it. See the collision note on FeeToolTipService.dripTranslations.
      labelTotalDue: drip.labelModalTotalDue,
      textTotalPlaceholder: drip.textTotalPlaceholder,
      ariaLabelPriceComponents: drip.ariaLabelPriceComponents
    };
    const key = JSON.stringify(translations);
    if (key !== this.dripBreakdownTranslationsKey) {
      this.dripBreakdownTranslationsKey = key;
      this.dripBreakdownTranslationsCache = translations;
    }
    return this.dripBreakdownTranslationsCache;
  }

  /**
   * inputConfig with the labelling element the current layout actually renders.
   *
   * The field is projected out of its <label for="make_offer_modal_input"> and into the breakdown,
   * which names it with its own base-amount label instead, so the labelledby has to follow it. It is on
   * the config object rather than a template binding, so this cannot be passed as template context the
   * way the bid modal passes labelledBy to its stepper.
   *
   * Mutates and returns the SAME object rather than spreading a copy: a getter handing a template a
   * fresh object every change-detection pass trips NG0100 in development builds. One config also means
   * getTranslations()' thousandSeparator patch keeps landing on the object the template reads.
   *
   * Which makes this depend on CurrencyInputComponent NOT being OnPush, invisibly from here. RUIC
   * declares it with no changeDetection, so it is Default and re-evaluates
   * [attr.aria-labelledBy]="inputConfig.inputAttrAriaLabelledBy" on every pass -- the only reason
   * mutating a field on an unchanged reference reaches the DOM at all. If it were made OnPush nothing
   * here would fail loudly: the breakdown would still render, the field would still work, and the input
   * would keep pointing at whichever label existed when the config was first read, so a screen reader
   * would announce the wrong label for a money field and nothing would say so. The fix would not be
   * local either -- a fresh reference per change is the NG0100 problem above, so it needs a signal input
   * or an ngOnChanges on RUIC's side.
   */
  get offerAmountInputConfig(): InputConfig {
    const labelledBy = this.showDripBreakdown
      ? `${this.dripIdPrefix}_base_label follow-up-offer-error`
      : 'follow-up-offer-label follow-up-offer-error';
    if (this.inputConfig.inputAttrAriaLabelledBy !== labelledBy) {
      this.inputConfig.inputAttrAriaLabelledBy = labelledBy;
    }
    return this.inputConfig;
  }

  private dripFeeRowsKey: string;
  private dripFeeRowsCache: ModalPriceBreakdownRow[];
  private dripBreakdownTranslationsKey: string;
  private dripBreakdownTranslationsCache: ModalPriceBreakdownTranslations;

  continue() {
    const offerAmount = this.parsedOfferAmount();
    const offerComment = this.form.get('offerComment').value;
    this.event.emit(new MakeOffer(offerAmount, offerComment));
    this.form.reset();
    this.intialOffer = true;
  }

  back() {
    this.intialOffer = true;
  }

  cancel() {
    this.event.emit(new Cancel());
  }
}
